import React, { useEffect, useState } from 'react';

// TODO: Replace with actual API when available
// import { getGoalsForSession, addGoalToSession } from '../services/plannerGoalService';

const PlannerSessionGoals = ({ sessionId }) => {
  const [goals, setGoals] = useState([]);
  const [newGoal, setNewGoal] = useState('');

  useEffect(() => {
    if (!sessionId) return;

    // TODO: Fetch goals for this session
    // getGoalsForSession(sessionId).then(setGoals).catch(console.error);
  }, [sessionId]);

  const handleAddGoal = async () => {
    if (!newGoal.trim()) return;

    // TODO: Send goal to backend
    // await addGoalToSession(sessionId, newGoal);
    // const updated = await getGoalsForSession(sessionId);
    // setGoals(updated);

    setGoals([...goals, { id: Date.now(), description: newGoal }]); // TEMP
    setNewGoal('');
  };

  return (
    <div>
      <h4>?? Session Goals</h4>

      <ul>
        {goals.map((goal) => (
          <li key={goal.id}>
            <strong>{goal.description}</strong>
          </li>
        ))}
      </ul>

      <input
        type="text"
        value={newGoal}
        onChange={(e) => setNewGoal(e.target.value)}
        placeholder="Describe new goal..."
      />
      <button onClick={handleAddGoal}>Add Goal</button>
    </div>
  );
};

export default PlannerSessionGoals;
